import React, { ReactElement, ForwardedRef } from 'react';
import CardInternal from '@mui/material/Card';
import FormatService from '../../services/format-service';
import useStylesCard from './card.styles';

const Card: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const ELEVATION_FLAT: number = 0;
  const ELEVATION_SHADOW_LIGHT: number = 1;
  const ELEVATION_SHADOW_MEDIUM: number = 2;

  const {
    isFlat,
    isDark,
    isScrollable,
    isContainer,
    isActive,
    isSelectable,
    isFullWidth,
    isFullHeight,
    withNoPadding,
    withSmallPadding,
    withLightShadow,
    withMediumShadow,
    withNoBackground,
    id,
    className,
    onClick,
    children,
  } = props;

  const { classes } = useStylesCard();

  const containerClassName: string | undefined = isContainer ? classes.cardContainer : undefined;
  const darkClassName: string | undefined = isDark ? classes.cardDark : undefined;
  const scrollableClassName: string | undefined = isScrollable ? classes.cardScrollable : undefined;
  const activeClassName: string | undefined = isActive ? classes.cardActive : undefined;
  const selectableClassName: string | undefined = isSelectable ? classes.cardSelectable : undefined;
  const fullWidthClassName: string | undefined = isFullWidth ? classes.cardFullWidth : undefined;
  const fullHeightClassName: string | undefined = isFullHeight ? classes.cardFullHeight : undefined;
  const noPaddingClassName: string | undefined = withNoPadding ? classes.cardNoPadding : undefined;
  const smallPaddingClassName: string | undefined = withSmallPadding ? classes.cardSmallPadding : undefined;
  const noBackgroundClassName: string | undefined = withNoBackground ? classes.cardNoBackground : undefined;
  const flatClassName: string | undefined = isFlat ? classes.cardFlat : undefined;

  const flatElevation: number | undefined = isFlat ? ELEVATION_FLAT : undefined;
  const lightShadowElevation: number | undefined = withLightShadow ? ELEVATION_SHADOW_LIGHT : undefined;
  const mediumShadowElevation: number | undefined = withMediumShadow ? ELEVATION_SHADOW_MEDIUM : undefined;

  return (
    <CardInternal
      ref={ref}
      id={id}
      elevation={flatElevation || lightShadowElevation || mediumShadowElevation}
      className={FormatService.formatClassNames(
        containerClassName, scrollableClassName, darkClassName, activeClassName, selectableClassName,
        fullWidthClassName, fullHeightClassName, noPaddingClassName, smallPaddingClassName, noBackgroundClassName,
        flatClassName, className,
      )}
      onClick={onClick}
    >
      {children}
    </CardInternal>
  );
}));

export default Card;
